const phpmyfaq: string = `
<svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1500 1500"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,1500) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M7410 14534 c-19 -2 -98 -9 -175 -14 -1187 -91 -2412 -550 -3235
-1214 -290 -234 -841 -728 -1156 -1038 l-141 -138 49 -193 c280 -1104 430
-1570 632 -1972 102 -201 160 -289 261 -391 129 -130 230 -165 347 -121 101
39 274 261 536 687 221 360 435 607 707 816 645 494 1413 764 2177 764 514 0
978 -101 1383 -300 304 -150 501 -305 705 -555 272 -335 452 -802 520 -1355
32 -259 41 -756 20 -1080 -71 -1102 -278 -1970 -617 -2593 -375 -690 -1018
-1315 -1868 -1814 -66 -39 -128 -80 -139 -92 -18 -20 -18 -22 4 -83 121 -326
425 -936 583 -1167 29 -42 31 -43 71 -37 92 14 533 258 871 481 757 500 1512
1213 2092 1975 406 535 701 1009 1002 1610 454 910 671 1586 746 2330 48 475
42 1030 -15 1430 -112 771 -449 1569 -924 2180 -124 160 -213 259 -395 444
-733 744 -1648 1202 -2736 1372 -335 52 -506 65 -900 69 -203 2 -386 1 -405
-1z"/>
<path d="M2415 10278 c-15 -46 -48 -169 -75 -275 -224 -880 -299 -1807 -215
-2649 120 -1204 554 -2193 1323 -3018 711 -761 1665 -1225 2767 -1346 55 -6
255 -14 444 -17 l344 -6 -6 68 c-9 90 -38 147 -112 220 -68 67 -116 101 -486
344 -1010 663 -1625 1302 -2033 2111 -228 450 -344 837 -402 1330 -14 121 -15
204 -10 500 6 369 11 449 47 662 l21 128 -50 62 c-50 65 -535 702 -1097 1443
-353 465 -400 525 -420 525 -9 0 -24 -32 -40 -82z"/>
<path d="M10335 3160 c-317 -20 -646 -135 -932 -327 -381 -255 -653 -633 -750
-1043 -30 -131 -42 -383 -24 -510 58 -392 310 -743 671 -934 112 -58 254 -110
365 -133 75 -15 137 -18 370 -18 246 1 292 3 377 22 219 48 629 246 813 393
77 62 231 218 290 295 153 199 273 458 327 709 16 77 22 136 22 251 1 167 -12
254 -56 395 -156 493 -644 858 -1200 895 -46 3 -101 7 -123 9 -22 1 -89 -1
-150 -4z"/>
</g>
</svg>
`;

export default phpmyfaq;
